(function($) {
    document.querySelectorAll('a').forEach(link => {
        const url = new URL(link.href, window.location.origin);
        const params = new URLSearchParams(window.location.search);
    
        // Dodanie parametrów do URL
        ['customer_id', 'time_create', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'ga_client_id'].forEach(param => {
            if (params.has(param)) {
                url.searchParams.set(param, params.get(param));
            }
        });
    
        link.href = url.toString();
    });


    $(document).ready(function () {
        //mobile menu
        $( '.header-navbar__mobile' ).click(
            function() {
                $( this ).toggleClass( 'open' );
                $( '.header-navbar__content' ).toggleClass( 'open' );
            }
		),
        //submenu
        $( '.menu-item-has-children>a' ).click(
            function(e) {
                var windowWidth = $( window ).width();
				if ( windowWidth < 1200 ) {
                    e.preventDefault();
                    $( this ).toggleClass( 'open' );
                    $( this ).siblings( '.sub-menu' ).toggleClass( 'open' );
                }
            }
		),
        $( '.menu-item-has-children.standard' ).mouseenter(
            function() {
                var windowWidth = $( window ).width();
				if ( windowWidth >= 1200 ) {
                    $( this ).children( 'a' ).addClass( 'open' );
                    $( this ).children( '.sub-menu' ).addClass( 'open' );
                }
            }
		),
        $( '.menu-item-has-children.standard' ).mouseleave(
            function() {
                var windowWidth = $( window ).width();
				if ( windowWidth >= 1200 ) {
                    $( this ).children( 'a' ).removeClass( 'open' );
                    $( this ).children( '.sub-menu' ).removeClass( 'open' );
                }
            }
		),
        //faq toggle
/*         $( '.faq__question' ).click(
            function() {
                $( this ).siblings( '.faq__answer' ).slideToggle();
                $( this ).children( '.faq__icon--plus' ).toggleClass( 'hide' );
                $( this ).children( '.faq__icon--minus' ).toggleClass( 'show' );
            }
        ), */
        // video
        $('.section-content-with-video__frame').each(function (index) {
        if ($(this).length) {
            $('.section-content-with-video__video-thumbnail').on('click', function () {
            $(this)
                .siblings('.section-content-with-video__popup')
                .find('.section-content-with-video__frame')
                .html(
                '<iframe allowfullscreen frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" class="embed-responsive-item" src="' +
                    $(this)
                    .siblings('.section-content-with-video__popup')
                    .find('.section-content-with-video__frame')
                    .data('yt-url') +
                    '?autoplay=1"></iframe>'
                );

            $(this)
                .siblings('.section-content-with-video__popup')
                .addClass('popup');

            $(this)
                .closest('.section-content-with-video')
                .addClass('section-content-with-video--popup-open');
            });
        }
        }),
        $('.section-content-with-video__close').click(function () {
            $('.section-content-with-video__popup').removeClass('popup');
            $('.section-content-with-video__frame').children('iframe').attr('src', '');
            $('.section-content-with-video').removeClass(
            'section-content-with-video--popup-open'
            );
        });

        //open close category of help center
        $( '.show-help-center-categories' ).click(
            function() {
                $( this ).toggleClass( 'show' );
                $( this ).siblings().children().children().toggleClass( 'show' );
            }
        ),
         //fixed menu
         $( window ).scroll(
            function() {
                if ( $( document ).scrollTop() > 50) {
                    $( '.site-header' ).addClass( 'fixed' );
                }
                else {
                    $( '.site-header' ).removeClass( 'fixed' );
                }
            }
        );

        if (document.getElementById("snt-main-popup") && document.cookie.indexOf( 'snt_main_popup=true' ) === -1) {

            showSenditPopup();

            const expires = new Date();
            expires.setHours(expires.getHours() + 24);
            document.cookie = 'snt_main_popup=true;expires=' + expires.toUTCString() + ';path=/;SameSite=Lax;Secure';
        }

        function showSenditPopup() {
            $( '#snt-main-popup' ).show();

            $( '.close-popup img' ).on('click', function() {
                $( '#snt-main-popup' ).hide();
            });
        }

    })
})( jQuery );

import Swiper from 'swiper';
import SwiperCore, { Navigation } from 'swiper';
SwiperCore.use([Navigation]);

//Reviews Slider
let reviewsSlider = new Swiper('.reviews-slider', {
    loop: true,
    slidesPerView: 1,
    navigation: {
        nextEl: '.reviews-slider__navigation--next',
        prevEl: '.reviews-slider__navigation--prev',
    },
});

document.addEventListener('DOMContentLoaded', () => {
    const languageWrapper = document.querySelector('.header-navbar__language-wrapper');
    const languageTrigger = document.querySelector('.header-navbar__language');

    if (languageTrigger && languageWrapper) {
        languageTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            languageWrapper.classList.toggle('is-active');
        });

        document.addEventListener('click', (e) => {
            if (!languageWrapper.contains(e.target)) {
                languageWrapper.classList.remove('is-active');
            }
        });
    }
});

